<template>
    <div class="header">
        <!-- 折叠按钮 -->

        <div class="head_container">
            <div class="logo_img">
                <div class="collapse-btn" @click="collapseChage">
                    <i v-if="!collapse" class="el-icon-s-fold"></i>
                    <i v-else class="el-icon-s-unfold"></i>
                </div>
                <img src="../../assets/img/logo2.png" alt="" style="height: 50px;width: 50px;margin: 0px auto;" />
            </div>
            <ul class="head_select">
                <li @click="gotoInfo('首页')" :class="type == '首页' ? 'select' : ''"><span>{{ $t('common.home') }}</span></li>

                <li @click="gotoInfo('营销管理')" :class="type == '营销管理' ? 'select' : ''"><span>{{ $t('common.marketingManagement') }}</span></li>
                <li
                    @click="gotoInfo('账款管理')"
                    :class="type == '账款管理' ? 'select' : ''"
                    v-if="systemSet ? systemSet.isaccouns == 1 : ''"
                >
                    <span>{{ $t('common.accountManagement') }}</span>
                </li>
                <li @click="gotoInfo('资料与设定')" :class="type == '资料与设定' ? 'select' : ''">
                    <span>{{ $t('common.dataAndSettings') }}</span>
                </li>
                <li @click="gotoInfo('系统设置')" :class="type == '系统设置' ? 'select' : ''">
                    <span>{{ $t('common.systemSettings') }}</span>
                </li>
            </ul>

            <div class="header-right">
                <div class="header-user-con">
                    <!-- 语言切换器 -->
                    <LanguageSwitcher class="language-switcher" />
                    
                    <span v-if="expirationInfo !== null && expirationInfo !== undefined && expirationInfo !== ''"
                          class="expirationInfo">{{ expirationInfo }}</span>
                    <!-- 全屏显示 -->
                    <div class="btn-fullscreen" @click="handleFullScreen">
                        <el-tooltip effect="dark" :content="fullscreen ? $t('common.exitFullscreen') : $t('common.fullscreen')" placement="bottom">
                            <i class="el-icon-rank"></i>
                        </el-tooltip>
                    </div>
                    <!-- 消息中心 -->
                    <div class="btn-bell">
                        <el-badge :value="message ? message : ''" :max="10">
                            <el-tooltip effect="dark" :content="message ? $t('common.unreadMessages', { count: message }) : $t('common.noUnreadMessages')" placement="bottom">
                                <router-link to="/tabs">
                                    <i class="el-icon-bell"></i>
                                </router-link>
                            </el-tooltip>
                        </el-badge>
                    </div>
                    <!-- 用户头像 -->
                    <div class="user-avator">
                        <img v-if="img" :src="img" />
                        <img v-else src="../../assets/img/img.png" />
                    </div>
                    <!-- 用户名下拉菜单 -->
                    <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                        <span class="el-dropdown-link">
                            {{ username }}
                            <i class="el-icon-caret-bottom"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <!-- <el-dropdown-item divided command="bindingWX">绑定微信</el-dropdown-item> -->
                            <el-dropdown-item divided command="editPwd">{{ $t('common.changePassword') || '修改密码' }}</el-dropdown-item>
                            <el-dropdown-item divided command="loginout">{{ $t('common.logout') || '退出登录' }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
        <!-- 修改密码弹出框 -->
        <el-dialog :title="$t('common.changePassword') || '修改密码'" :visible.sync="editPwdData.isshow" width="50%">
            <el-form label-width="120px">
                <el-form-item :label="$t('common.oldPassword') || '旧密码'">
                    <el-input type="password" v-model="editPwdData.data.old_password" show-password></el-input>
                </el-form-item>
                <el-form-item :label="$t('common.newPassword') || '新密码'">
                    <el-input type="password" v-model="editPwdData.data.password" show-password></el-input>
                </el-form-item>
                <el-form-item :label="$t('common.confirmPassword') || '再次输入密码'">
                    <el-input type="password" v-model="editPwdData.data.password_two" show-password></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editPwdData.isshow = false">{{ $t('common.back') || '返回' }}</el-button>
                <el-button type="primary" @click="editPwdSubmit">{{ $t('common.modify') || '修改' }}</el-button>
            </span>
        </el-dialog>
        <!-- 绑定微信 -->
        <el-dialog :title="$t('common.bindWechat') || '绑定微信'" :visible.sync="QRshow" width="50%">
            <div class="img_wrap">
                <img :src="QR" alt="" />
                <i class="el-icon-refresh-left icons" @click="QRcode"></i>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Utils from '../../assets/util.js';
import bus from '../common/bus';
import LanguageSwitcher from './LanguageSwitcher.vue';
import { apiGetinfo, apimodifyPwd, apiNoticeNum, apiLogin_QR, apiLogin_bd_scanQR, quitLogin, apiSystem } from '@/request/api'; // 导入我们的api接口
export default {
    components: {
        LanguageSwitcher
    },
    data() {
        return {
            type: '',
            collapse: false,
            fullscreen: false,
            message: '',
            username: '',
            expirationInfo: '',
            img: '',
            editPwdData: {
                isshow: false,
                scope: null,
                index: 0,
                data: {}
            },

            QRshow: false,
            QR: '',
            ticket: '',
            timeID: '',
            systemSet: ''
        };
    },
    computed: {},
    watch: {
        $route(n) {
            // this.type = localStorage.getItem('type') || '销售管理';
            // this.type = n.matched[0].meta.title;
        }
    },
    created: function () {
        this.getSystem();
        this.type = localStorage.getItem('type') || this.$t('common.home');
        apiGetinfo({}).then((res) => {
            if (res.code == 2000) {
                this.username = res.data.staffr_name;
                this.expirationInfo = res.data.expirationInfo;
                this.img = res.data.img;
                //
            } else {
                this.$message.error(res.msg);
            }
        });
        this.getNotice();
    },
    methods: {
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        gotoInfo(index) {
            this.type = index;
            localStorage.setItem('type', index);
            bus.$emit('request');
        },

        back() {
            // this.$router.go(-1);//返回上一层
            this.$router.push('/select');
        },
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'loginout') {
                this.outLogin();
            } else if (command == 'editPwd') {
                this.editPwdData.isshow = true;
                this.editPwdData.data = {
                    old_password: '',
                    password: '',
                    password_two: ''
                };
            } else if (command == 'bindingWX') {
                this.QRcode();
            }
        },
        outLogin() {
            quitLogin().then((res) => {
                sessionStorage.removeItem('userToken');
                localStorage.removeItem('local_token');
                this.$router.push('/login');
            });
        },
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },
        // 二维码
        QRcode() {
            this.$load.show();
            apiLogin_QR({
                type: this.$bus.data.type
            }).then((res) => {
                this.$load.close();
                this.QRshow = true;
                this.QR = res.img;
                this.ticket = res.ticket;
                this.timer();
            });
        },
        // 获取扫码状态
        timer() {
            if (this.timeID) clearTimeout(this.timeID);
            this.timeID = setTimeout(() => {
                apiLogin_bd_scanQR({
                    ticket: this.ticket,
                    login_staff: localStorage.getItem('ms_username'),
                    type: this.$bus.data.type
                }).then((res) => {
                    let { type, content } = res.data;
                    if (res.code == 2000) {
                        if (type == 1) {
                            this.$message.success(this.$t('common.bindSuccess'));
                            this.QRshow = false;
                        } else if (type == 2) {
                            this.QRcode();
                        } else if (type == 0) {
                            this.timer();
                        }
                    }
                });
            }, 2600);
        },
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
        editPwdSubmit() {
            let data = this.editPwdData.data;
            apimodifyPwd(data).then((res) => {
                if (res.code == 2000) {
                    this.$message({
                        message: this.$t('common.passwordModified'),
                        type: 'success'
                    });
                    this.editPwdData.isshow = false;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        getNotice() {
            apiNoticeNum({}).then((res) => {
                if (res.code == 2000) {
                    this.message = res.data.no;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
    },
    mounted() {
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }
        var that = this;
        Utils.$on('demo', (msg) => {
            that.getNotice();
        });
    }
};
</script>
<style scoped lang="scss">
.head_select {
    display: flex;
    height: 100%;
    justify-content: flex-start;
    align-items: center;
    width: 0;
    flex: 1;
    height: 70px;
    li {
        list-style: none;
        width: 135px;
        cursor: pointer;
        font-size: 18px;
        text-align: center;
        height: 100%;
        line-height: 70px;
    }
    .select {
        background: #0084ff;
    }
}
</style>
<style scoped>
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
    margin-bottom: 16px;
    /* background: url('../../../screenshots/bg.jpg')no-repeat;
    background-size:100% 100%;
    -webkit-background-origin:content-box; 
    background-origin:content-box; */
}
.expirationInfo{
    color: #fff !important;
    font-size: 14px;
    font-weight: 500;
    padding: 6px 12px;
    background: linear-gradient(45deg, #ff6b35, #f7931e);
    border-radius: 16px;
    margin-right: 15px;
    box-shadow: 0 2px 6px rgba(255, 102, 0, 0.3);
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.2);
}
.head_container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.collapse-btn {
    padding: 0 21px;
    cursor: pointer;
    line-height: 70px;
}

.header .logo {
    line-height: 70px;
}

.header-right {
    padding-right: 50px;
}

.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
}

.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}

.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
}

.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
}

.btn-bell .el-icon-bell {
    color: #fff;
}

.user-name {
    margin-left: 10px;
}

.user-avator {
    margin-left: 20px;
}

.user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

/* 语言切换器样式 */
.language-switcher {
    margin-right: 15px;
}

.language-switcher .el-dropdown-link {
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    padding: 6px 12px;
    border-radius: 4px;
    transition: background-color 0.3s;
}

.language-switcher .el-dropdown-link:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.active-language {
    color: #409eff;
    font-weight: bold;
}

.el-dropdown-menu__item {
    text-align: center;
}

.el-badge__content {
    border: none !important;
}
</style>
<style lang="scss">
.img_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;

    .icons {
        cursor: pointer;
        font-size: 25px;
        line-height: 32px;
        margin-bottom: 10px;
    }
}

.logo_img {
    width: 250px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    img {
        width: 130px;
    }
}
</style>
